module.exports = "../dist/img/img_3-23.af30.jpg";